// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"6546ab37","580":"d5f20307","787":"d7af9de9","959":"09464fd0"}[chunkId] + ".chunk.js";
};